// src/config/TutorBookingLinks.js

export const tutorBookingLinks = {
  Edward: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Eli: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Ben: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Patrick: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Kyra: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Kieran: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
  Omar: {
    'individualLink': 'https://leetutoring.youcanbook.me/selectTime?i=itt_b156ca3e-4d64-4db6-bd61-9dd43644592c',
  },
};
